import { render, staticRenderFns } from "./multipleChoice5.vue?vue&type=template&id=0f3dfb1d&scoped=true"
import script from "./multipleChoice5.vue?vue&type=script&lang=js"
export * from "./multipleChoice5.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice5.vue?vue&type=style&index=0&id=0f3dfb1d&prod&lang=css"
import style1 from "./multipleChoice5.vue?vue&type=style&index=1&id=0f3dfb1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3dfb1d",
  null
  
)

export default component.exports